"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sortable = exports.SortableState = exports.SortDirection = exports.CSS = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const timsort_1 = require("timsort");
const index_1 = require("../../i18n/index");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const image_button_1 = require("../button/image.button");
const icons_1 = require("../icon/icons");
const menu_1 = require("../menu/menu");
const menu_item_1 = require("../menu/menu.item");
const mithril_component_1 = require("../mithril.component");
const theme_1 = require("../theme");
exports.CSS = {
    container: 'c-Sortable',
    button: 'c-Sortable__Button',
    order: {
        ascending: 'c-Sortable__Ascending',
        descending: 'c-Sortable__Descending',
        container: 'c-Sortable__Order',
    },
};
(0, theme_1.addStyles)({
    [exports.CSS.button]: {
        color: theme_1.DefaultTheme.font.color.primary,
        padding: `0 ${theme_1.DefaultTheme.space(1)}`,
        'font-family': theme_1.DefaultTheme.font.family,
        'font-weight': 'inherit',
        'text-transform': 'inherit',
    },
    [exports.CSS.order.ascending]: {
        'border-top': `1px solid ${theme_1.DefaultTheme.font.color.divider}`,
    },
});
var SortDirection;
(function (SortDirection) {
    SortDirection[SortDirection["ASCENDING"] = 1] = "ASCENDING";
    SortDirection[SortDirection["DESCENDING"] = -1] = "DESCENDING";
})(SortDirection || (exports.SortDirection = SortDirection = {}));
const SortIcon = {
    [SortDirection.ASCENDING]: icons_1.MaterialIcon.KEY_UP,
    [SortDirection.DESCENDING]: icons_1.MaterialIcon.KEY_DOWN,
};
class SortableState {
    constructor(sortOptions) {
        this.direction = SortDirection.DESCENDING;
        this.options = sortOptions;
        if (this.options.length > 0) {
            this.option = this.options[0];
        }
    }
    get isAscending() {
        return this.direction === SortDirection.ASCENDING;
    }
    toggleDirection() {
        if (this.direction === SortDirection.ASCENDING) {
            this.direction = SortDirection.DESCENDING;
        }
        else {
            this.direction = SortDirection.ASCENDING;
        }
        this.track();
    }
    setSort(sortOption) {
        this.option = sortOption;
        this.track();
    }
    sortTags(objs) {
        return this.sortObjects(objs, 'tag');
    }
    sortSummaries(objs) {
        return this.sortObjects(objs, 'collection');
    }
    getCollectionDisplayValue(obj) {
        const currentOption = this.option;
        if (currentOption.info.collection == null || currentOption.info.collection === false) {
            return null;
        }
        if (currentOption.value != null && currentOption.value.collection != null) {
            return currentOption.value.collection(obj);
        }
        const sortKey = currentOption.keys.collection;
        if (typeof sortKey === 'string') {
            return obj[sortKey];
        }
        return sortKey(obj);
    }
    sortObjects(objs, key) {
        const currentOption = this.option;
        const direction = this.direction;
        const sortKey = currentOption.keys[key];
        const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
        function compareFunc(a, b) {
            let aKey;
            let bKey;
            if (typeof sortKey === 'string') {
                if (sortKey === 'title') {
                    aKey = a['title'] || a['subtitle'];
                    bKey = b['title'] || b['subtitle'];
                }
                else {
                    aKey = a[sortKey];
                    bKey = b[sortKey];
                }
            }
            else {
                aKey = sortKey(a);
                bKey = sortKey(b);
            }
            // Ensure a stable sort by using updatedAt and objectId as a extra indexes
            if (aKey === bKey) {
                if (a.updatedAt !== b.updatedAt) {
                    aKey = a.updatedAt;
                    bKey = b.updatedAt;
                }
                else {
                    aKey = a.objectId;
                    bKey = b.objectId;
                }
            }
            // only use collator for title otherwise fallback to default sorting
            if (sortKey === 'title') {
                return collator.compare(aKey, bKey) * direction;
            }
            // IKE4-2322 Explicitly compare against null and undefined, where equality is problematic.
            // e.g: 'a' > null (false), 'a' < null (false), 'a' == null (false)
            if (aKey == null || bKey == null) {
                if (aKey != null && bKey == null) {
                    return direction;
                }
                else if (aKey == null && bKey != null) {
                    return -1 * direction;
                }
                return 0;
            }
            else if (aKey > bKey) {
                return direction;
            }
            else if (aKey < bKey) {
                return -1 * direction;
            }
            return 0;
        }
        (0, timsort_1.sort)(objs, compareFunc);
        return objs;
    }
    track() {
        const direction = this.direction === SortDirection.DESCENDING ? 'Descending' : 'Ascending';
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.BigMap, 'Sort', `${this.option.title}:${direction}`);
    }
}
exports.SortableState = SortableState;
tslib_1.__decorate([
    mobx_1.observable
], SortableState.prototype, "direction", void 0);
tslib_1.__decorate([
    mobx_1.observable
], SortableState.prototype, "option", void 0);
tslib_1.__decorate([
    mobx_1.computed
], SortableState.prototype, "isAscending", null);
tslib_1.__decorate([
    mobx_1.action.bound
], SortableState.prototype, "toggleDirection", null);
tslib_1.__decorate([
    mobx_1.action
], SortableState.prototype, "setSort", null);
class Sortable extends mithril_component_1.IMithrilComponent {
    constructor(state) {
        super();
        this.isOpen = false;
        this.state = state;
        this.menu = new menu_1.MenuComponent({
            items: () => this.viewMenuItems(this.state),
        });
    }
    get nodes() {
        const title = (0, index_1.Translate)(index_1.T.SORT_TITLE);
        const className = `mdl-button ${exports.CSS.button}`;
        return mithril_1.m.fragment({}, [
            this.menu.view(),
            (0, mithril_1.m)('button', { className, onclick: this.menu.show, title }, [(0, index_1.Translate)(this.state.option.title)]),
            image_button_1.ImageButton.view(SortIcon[this.state.direction], { onclick: this.state.toggleDirection }),
        ]);
    }
    viewMenuItems(sortable) {
        const items = [];
        for (const opt of sortable.options) {
            if (opt.visible != null && !opt.visible()) {
                continue;
            }
            items.push({
                selected: sortable.option.title === opt.title,
                view: menu_item_1.MenuItemComponent.view((0, index_1.Translate)(opt.title), opt.icon),
                action: () => sortable.setSort(opt),
            });
        }
        return items;
    }
}
exports.Sortable = Sortable;
tslib_1.__decorate([
    mobx_1.observable
], Sortable.prototype, "isOpen", void 0);
//# sourceMappingURL=sortable.js.map